var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("emd-container", {
        attrs: { title: _vm.$t("title") },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "eu-flex" }, [
                  _c(
                    "div",
                    { staticClass: "eu-flex-item eu-basis_12 eu-basis_12_md" },
                    [
                      _c(
                        "div",
                        { staticClass: "emd-form-group" },
                        [
                          _c("label", { staticClass: "emd-label" }, [
                            _vm._v(_vm._s(_vm.$t("shipping")) + " "),
                            _c("span", { staticClass: "label-optional" }, [
                              _vm._v("(" + _vm._s(_vm.$t("optional")) + ")"),
                            ]),
                          ]),
                          _c("emd-input-money", {
                            model: {
                              value: _vm.shipping,
                              callback: function ($$v) {
                                _vm.shipping = $$v
                              },
                              expression: "shipping",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }